import { Component, OnInit } from '@angular/core';
import { OfferItem as addAncilliariesOfferItem } from 'src/app/model/screen/add-ancilliaries-screen';
import { Passenger as PassengerScreenPassenger, PassengerDetailScreen } from 'src/app/model/screen/passenger-detail-screen';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';

@Component({
  selector: 'app-add-ancilliaries-screen',
  templateUrl: './add-ancilliaries-screen.component.html',
  styleUrls: ['./add-ancilliaries-screen.component.scss']
})
export class AddAncilliariesScreenComponent implements OnInit {
  constructor(private sandboxPageStateService: SandboxPageStateService, private apiService: ApiService, private localAssetReaderService: LocalAssetReaderService) {}

  public passengerDetails: PassengerScreenPassenger[] = [];
  public displayService: any;
  public passengerServiceButtonArray: any = [];
  ngOnInit(): void {
    this.checkApplicableService();
    let passengerDetailScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    this.passengerDetails = passengerDetailScreenData.passengerDetail;
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    this.displayService = addAncilliariesScreenData.displayService;
  }
  checkApplicableService() {
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let addAncilliariesScreenJsonData = addAncilliariesScreenData.json;
    let seatEnvelope = addAncilliariesScreenJsonData['SOAP:ENVELOPE'];
    let seatBody = seatEnvelope['SOAP:BODY'][0];
    let searviceListReponse = seatBody.SERVICELISTRS[0];
    let addBaggageOfferDetails = searviceListReponse.ALACARTEOFFER[0];
    let offerItems = addBaggageOfferDetails.ALACARTEOFFERITEM;
    let addBaggageOfferDetailsLength = offerItems.length;
    if (addBaggageOfferDetailsLength > 0) {
      offerItems.forEach((offer: any) => {
        let passengerRefs = offer.ELIGIBILITY[0].PASSENGERREFS[0].split(' ');
        let offerItemId = offer.$.OFFERITEMID;
        let offerItemIdArray = offerItemId.split('-');
        let offerServiceType = offerItemIdArray[offerItemIdArray.length - 1];
        passengerRefs.forEach((passengerRef: any) => {
          let passengerCutomRef = passengerRef + '-' + offerServiceType;
          let passengerCutomRefIndex: any = this.passengerServiceButtonArray.indexOf(passengerCutomRef);
          if (passengerCutomRefIndex === -1) {
            this.passengerServiceButtonArray.push(passengerCutomRef);
          }
        });
      });
    }
  }

  check_button_available(passengerId: any, type: 'MEAL' | 'BAG' | 'DisabilityAssistance' | 'CARB') {
    let passengerCutomRef = passengerId + '-' + type;
    let passengerCutomRefIndex: any = this.passengerServiceButtonArray.indexOf(passengerCutomRef);
    if (passengerCutomRefIndex === -1) {
      return false;
    } else {
      return true;
    }
  }
  displayServiceScreen(passengerIndex: any, type: 'MEAL' | 'BAG' | 'DisabilityAssistance' | 'CARB') {
    let selectedPassengerDetail = this.passengerDetails[passengerIndex];

    let addBaggageScreenDetail = this.sandboxPageStateService.getAddBaggageScreenDetail();
    addBaggageScreenDetail.bookingType = 'your-booking-screen-add-ancilliaries';
    addBaggageScreenDetail.serviceType = type;
    addBaggageScreenDetail.passengerIndex = passengerIndex;
    addBaggageScreenDetail.passengerId = selectedPassengerDetail.passengerId;
    addBaggageScreenDetail.passengerName = selectedPassengerDetail.passengerName + ' ' + selectedPassengerDetail.passengerSurName;
    addBaggageScreenDetail.boundBaggageList = [];
    addBaggageScreenDetail.climateProductDetails = selectedPassengerDetail.passengerOtherDetails.passengerProductClimateServiceDetail;
    this.sandboxPageStateService.updateAddBaggageScreenDetail(addBaggageScreenDetail);

    let patchSandboxSourceData = { mainMenu: 'add-baggage' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  removeServiceFromPassenger(type: 'MEAL' | 'BAG' | 'DisabilityAssistance' | 'CARB', passengerIndex: any, serviceIndex: any) {
    let selectedOfferItemId: any = '';
    if (type === 'BAG') {
      selectedOfferItemId = this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedBaggageDetail[serviceIndex].baggageName;
      this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedBaggageDetail.splice(serviceIndex, 1);
    } else if (type === 'MEAL') {
      selectedOfferItemId = this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedMealDetails[serviceIndex].baggageName;
      this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedMealDetails.splice(serviceIndex, 1);
    } else if (type === 'DisabilityAssistance') {
      selectedOfferItemId = this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedDisablityServiceDetail[serviceIndex].baggageName;
      this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedDisablityServiceDetail.splice(serviceIndex, 1);
    } else if (type === 'CARB') {
      selectedOfferItemId = this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedProductClimateServiceDetail[serviceIndex].baggageName;
      this.passengerDetails[passengerIndex].passengerOtherDetails.passengerSelectedProductClimateServiceDetail.splice(serviceIndex, 1);
    }
    let passengerDetailScreenData = this.sandboxPageStateService.getPassengerDetailScreenData();
    passengerDetailScreenData.passengerDetail = this.passengerDetails;
    this.sandboxPageStateService.updatePassengerDetailScreenData(passengerDetailScreenData);
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let selectedOffers = addAncilliariesScreenData.selectedOfferItem;
    let selectedOfferLength = selectedOffers.length;
    if (selectedOfferLength > 0) {
      selectedOffers.forEach((selectedOffer: addAncilliariesOfferItem, selectedOfferItemIndex) => {
        if (selectedOffer.offerItemID === selectedOfferItemId) {
          addAncilliariesScreenData.selectedOfferItem.splice(selectedOfferItemIndex, 1);
          addAncilliariesScreenData.selectedOfferItem = addAncilliariesScreenData.selectedOfferItem;
        }
      });
    }
    let selectedOfferItemLength = addAncilliariesScreenData.selectedOfferItem.length;
    if (selectedOfferItemLength === 0) {
      addAncilliariesScreenData.displayService = 'All';
    }
    this.sandboxPageStateService.updateAddAncilliariesScreenData(addAncilliariesScreenData);
    this.displayService = addAncilliariesScreenData.displayService;
  }
  closeScreen() {
    let patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
  ShowOrderView() {
    let totBagAmount: any = 0;
    let totMealAmount: any = 0;
    let totDisablityAmount: any = 0;
    let totCarbAmount: any = 0;
    let total: any = 0;
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let selectedOfferItem = addAncilliariesScreenData.selectedOfferItem;
    let selectedOfferItemLength = selectedOfferItem.length;
    if (selectedOfferItemLength > 0) {
      selectedOfferItem.forEach((offerItem: addAncilliariesOfferItem) => {
        total += +offerItem.price;
        if (offerItem.type === 'BAG') {
          totBagAmount += +offerItem.price;
        } else if (offerItem.type === 'MEAL') {
          totMealAmount += +offerItem.price;
        } else if (offerItem.type === 'DisabilityAssistance') {
          totDisablityAmount += +offerItem.price;
        } else if (offerItem.type === 'CARB') {
          totCarbAmount += +offerItem.price;
        }
      });
    }
    let confimrmBookingScreenData = this.sandboxPageStateService.getConfirmBookingScreenData();
    if (total > 0) {
      confimrmBookingScreenData.bookingType = 'post-booking-add-paid-ancilliaries-service';
    } else {
      confimrmBookingScreenData.bookingType = 'post-booking-add-free-ancilliaries-service';
    }
    confimrmBookingScreenData.postBookingAncilliariesDetail = {
      priceDetails: {
        disablityAssistancePrice: totDisablityAmount,
        mealPrice: totMealAmount,
        bagPrice: totBagAmount,
        cardFee: '0',
        carbPrice: totCarbAmount,
        totalCharge: total,
        priceCode: addAncilliariesScreenData.currency
      }
    };
    this.sandboxPageStateService.updateConfirmBookingScreenData(confimrmBookingScreenData);
    let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
    yourBookingScreenData.displayConfirmBookingForm = true;
    this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

    let patchSandboxSourceData: any = { mainMenu: 'your-booking-screen' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
}
